import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import LogoCarousel from '../../components/WebsiteUI/LogoCarousel';
import styles from './HeroSection.module.css';

const RiveHero = React.lazy(() => import('../../components/WebsiteUI/RiveHero'));

const HeroSection = () => {
  const sectionRef = useRef(null);
  const contentRef = useRef(null);
  const textBlockRef = useRef(null);
  const logosRef = useRef(null);

  useEffect(() => {
    if (!sectionRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            contentRef.current?.classList.add(styles['hero--visible']);
            textBlockRef.current?.classList.add(styles['hero--visible']);
            logosRef.current?.classList.add(styles['hero--visible']);
          } else {
            contentRef.current?.classList.remove(styles['hero--visible']);
            textBlockRef.current?.classList.remove(styles['hero--visible']);
            logosRef.current?.classList.remove(styles['hero--visible']);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className={styles.hero} ref={sectionRef}>
      <div className={styles.hero__bg} aria-hidden="true">
        <div className={styles['hero__bg-color']}></div>
        <div className={styles['hero__bg-pattern']}>
          <img src="/assets/website/hero-bg.png" alt="" />
        </div>
        <div className={styles['hero__bg-overlay']}></div>
        <div className={styles['hero__bg-rive']}>
          <React.Suspense fallback={null}>
            <RiveHero className={styles.hero__rive} />
          </React.Suspense>
        </div>
      </div>

      <div className={styles.hero__container}>
        <div className={styles.hero__content} ref={contentRef}>
          <div className={styles['hero__text-block']} ref={textBlockRef}>
            <div className={styles.hero__headings}>
              <h1 className={styles.hero__title}>Built for Providers. Powered by Innovation.</h1>
              <p className={styles.hero__subtitle}>
                Manage documentation, progress note, care plans, eMAR, billing, compliance, and reporting with AI-driven tools that save time and elevate care.
              </p>
            </div>
            <div className={styles.hero__cta}>
              <Link to="/book-demo" className={styles.hero__button}>Request a demo</Link>
            </div>
          </div>
        </div>
        <div className={styles.hero__logos} ref={logosRef}>
          <LogoCarousel />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
